import encodeQueryData from "../utils/encodeQueryData";
import Fetch from "./Fetch";
import FormData from 'form-data';
import { env } from '../var/env';
import Storage from "../utils/storage";

const storageSession = Storage('session');
const storageLocal = Storage('local');

function client () {

    const url = env.REACT_APP_API_PATH + '/'

    const generateHeaders = (options = {}) => {

        const token = storageLocal.get('token');
        if(token) {
            options.Authorization = 'Bearer ' + token
        }

        return options;
    };

    const fetchInterceptorRequest = (url, options) => {
        const company = storageSession.get('company');
        if(location.pathname.startsWith('/company') && company) {
            url += ( url.match( /[\?]/g ) ? '&' : '?' ) + `company=${company.id}`;
        }
        
        if(!company && location.pathname.startsWith('/company')) {
            var company_name = location.pathname.split("/company/")[1].split("/")[0];
            console.log(location.pathname.split("/company"));
            url += ( url.match( /[\?]/g ) ? '&' : '?' ) + `company=${company_name}`;
        }

        options = {
            ...options,
            headers: {
              ...options.headers,
              'Ngrok-Skip-Browser-Warning': 'true',
            }
        };
    
        return {url, options};
    }

    const fetchInterceptorResponse = async(response, error, request) => {
        if(error === null || error.status != 401 || storageLocal.get('token') == false) return [response, error];

        const { url : uri, options } = request;
        ([response, error]) = await Fetch(`${url}refresh-token`, {
            method: 'post',
            headers: generateHeaders({
                'Content-Type': 'application/json',
                'Ngrok-Skip-Browser-Warning': 'true'
            }),
            body : JSON.stringify({refresh_token : storageLocal.get('refresh_token')})
        });

        if(error) {
            return [response, error];
        }

        const { token } = response;
        storageLocal.set('token', token);
        options.headers = generateHeaders(options.headers);
        [response, error] = await Fetch(uri, options);

        return [response, error];

    }

    const apiCall = async (...arg) => {
        const {url, options} = fetchInterceptorRequest(...arg);
        let [response, error] = await Fetch(url, options);
        [response, error] = await fetchInterceptorResponse(response, error, {url, options})
        return [response, error];
    }
    
    return {
        get: function(uri, params = {}){
            const content = {
                method: 'get',
                headers: generateHeaders({
                    'Content-Type': 'application/json'
                })
            }

            const data = encodeQueryData(params);

            return apiCall(url + uri + (data ? '?' + data : '') , content);
        },
        post: function(uri, data){
            const content = {
                method: 'post',
                headers: generateHeaders()
            }

            if(data instanceof FormData === false ) {
                content.headers = generateHeaders({ 'Content-Type': 'application/json'} );
                content.body = JSON.stringify(data);
            }
            else {
                content.body = data;
            }

            return apiCall(url + uri, content);
        },
        put: function(uri, data){
            const content = {
                method: 'put',
                headers: generateHeaders()
            }

            if(data instanceof FormData === false) {
                content.headers = generateHeaders({ 'Content-Type': 'application/json'} );
                content.body = JSON.stringify(data);
            }
            else {
                content.method = 'post';
                uri = uri + '?_method=PUT';
                content.body = data;
            }

            return apiCall(url + uri, content);
        },
        delete: function (uri, params = {}) {
            const content = {
                    method: 'delete',
                    headers: generateHeaders({
                    'Content-Type': 'application/json',
                }),
            };

            const queryString = encodeQueryData(params);
            const fullUrl = queryString ? `${url}${uri}?${queryString}` : `${url}${uri}`;

            return apiCall(fullUrl, content);
        }

    }
}

export default client();